<template lang="pug">
.sentencia-recurso(v-if="iterProcesalVisible")
  h6
    | {{ iterProcesal.label.toUpperCase() }}
  .iter-tree(v-for="iter in iterProcesal.values")
    ul
      documents-iter-procesal-detail-vue(
        v-bind="iter"
        :current-id="id"
      )
</template>

<script>
import mixins from 'common/mixins'

export default {
  name: 'documents-iter-procesal-vue',
  props: {
    id: { type: Number, default: 0 },
    metadataFields: { type: Array, default: () => [] }
  },
  mixins: [mixins.translate],
  components: {
    'documents-iter-procesal-detail-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/documents/DocumentsIterProcesalDetail'
    )
  },
  computed: {
    iterProcesal() {
      return this.metadataFields.find(field => field.id == 'iter_procesal')
    },
    iterProcesalVisible() {
      return this.iterProcesal && this.iterProcesal.values.length > 0
    }
  }
}
</script>
